import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppPptPurchasePeriodService,
  // eslint-disable-next-line camelcase
  PagedResultDto_EsppPptPurchasePeriodResponseVm,
} from '../../services/wealthlane-award-services';
import { TableParams, type TableParamsType } from '../../types/common';

const useGetParticipantEsppOfferingList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_EsppPptPurchasePeriodResponseVm | undefined,
  unknown
> => {
  const { sorting, skipCount, maxResultCount, planIds, filter } = tableInfo;

  const participantEsppOfferingList = useQuery(
    ['getParticipantEsppOfferingList', sorting, skipCount, maxResultCount, planIds, filter],
    async () => {
      return await handleRequest(
        EsppPptPurchasePeriodService.getApiAwardApiPptEsppPurchasePeriod(
          false,
          false,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return participantEsppOfferingList;
};

export default useGetParticipantEsppOfferingList;
